(function () {
    "use strict";


    // @ngInject
    function NetworkServiceCtor(ModalService) {

        this.ModalService = ModalService;

        //Note the order in this array is not the order of the real enum numbers,
        //but rather the order in which the project types are presented in menus
        //i.e. DO NOT rely on this for code like "projectTypeEnum[company.project_type_cd]"
        this.projectTypeEnum = [
            {key: null, text: 'NETWORK.PROJECT_TYPES._NONE_'},
            {key: 'wedding', text: 'NETWORK.PROJECT_TYPES._WEDDING_'},
            {key: 'corporate', text: 'NETWORK.PROJECT_TYPES._CORPORATE_'},
            {key: 'social', text: 'NETWORK.PROJECT_TYPES._SOCIAL_'},
            {key: 'event', text: 'NETWORK.PROJECT_TYPES._PROJECT_'},
            {key: 'party', text: 'NETWORK.PROJECT_TYPES._PARTY_'},
            {key: 'family', text: 'NETWORK.PROJECT_TYPES._FAMILY_'},
            {key: 'design', text: 'NETWORK.PROJECT_TYPES._DESIGN_'},
            {key: 'other', text: 'NETWORK.PROJECT_TYPES._OTHER_'}
        ];

        this.projectTypeTranslationMap = {};
        this.projectTypeEnum.forEach(function (entry) {
            this.projectTypeTranslationMap[entry.key] = entry.text;
        }.bind(this));

    }

    Services.NetworkService = Class(function () {


        return {

            constructor: NetworkServiceCtor,

            getProjectTypesEnum: function getProjectTypesEnum() {
                return this.projectTypeEnum;
            },

            getProjectTypesTranslationMap: function getCompanyTypesTranslationMap() {
                return this.projectTypeTranslationMap;
            },

            getSelectedProjectTypeFromEnum: function getSelectedProjectTypeFromEnum(project) {
                var self = this;
                var selectedProjectType = this.projectTypeEnum[0];
                if (project) {
                    this.projectTypeEnum.forEach(function (type) {
                        if (project.project_type === type.key) {
                            selectedProjectType = type;
                            return;
                        }
                    });
                }

                return selectedProjectType;
            },

            tagNetworkVendors: function tagNetworkVendors(project){
                return this.ModalService.openNewTagVendorModal(project);
            },

            inviteUsers: function inviteUsers(){
                return this.ModalService.openInviteNetworkUserModal();
            },

            inviteUser: function inviteUser(){
                return this.ModalService.openInviteNetworkUserModal();
            },

        };
    });
}());
